define('viewmodels/pages/itunesTerms',[], function () {

    function ItunesTerms (terms) {
        this.terms = terms('terms');
    }

    return ItunesTerms;
});

